(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.install(root);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';

  function normalize(value) { return String(value || '').trim().toUpperCase(); }
  function unique(values) { return Array.from(new Set(values.map(normalize).filter(Boolean))); }
  function managed(code) { return normalize(code).indexOf('CS-DESIGN15-') === 0; }

  function designIdentity(value) {
    var tag = String(value || '').trim();
    var canonical = tag.toLowerCase();
    if (canonical.indexOf('design:') !== 0 || !canonical.slice(7).trim()) return null;
    var name = canonical.slice(7).trim();
    var slug = name.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40) || 'design';
    var hash = 2166136261;
    for (var i = 0; i < canonical.length; i++) hash = Math.imul(hash ^ canonical.charCodeAt(i), 16777619);
    return { tag: tag, code: 'CS-DESIGN15-' + slug.toUpperCase() + '-' + (hash >>> 0).toString(16).padStart(8, '0').toUpperCase() };
  }

  function collectCodes(cart) {
    var codes = (cart.discount_codes || []).map(function (entry) { return typeof entry === 'string' ? entry : entry.code; });
    function collect(allocation) {
      var discount = allocation.discount_application || allocation;
      if (discount.type === 'discount_code') codes.push(discount.title);
    }
    (cart.cart_level_discount_applications || []).forEach(collect);
    (cart.items || []).forEach(function (item) { (item.line_level_discount_allocations || []).forEach(collect); });
    return unique(codes);
  }

  function planCodes(metadata, cart, config, manualIntent) {
    var present = collectCodes(cart);
    var manual = unique(manualIntent == null ? present.filter(function (code) { return !managed(code); }) : manualIntent);
    var groups = new Map();
    (config.groups || []).forEach(function (entry) {
      groups.set(String(entry.tag).trim().toLowerCase(), { tag: entry.tag, code: normalize(entry.code), quantity: 0, subtotal: 0 });
    });
    (metadata.items || []).forEach(function (item) {
      unique(item.tags || []).forEach(function (tag) {
        var group = groups.get(tag.toLowerCase());
        if (!group && config.autoRegisterDesigns === true) {
          var identity = designIdentity(tag);
          if (identity) {
            group = { tag: identity.tag, code: identity.code, quantity: 0, subtotal: 0 };
            groups.set(tag.toLowerCase(), group);
          }
        }
        if (group) {
          group.quantity += Math.max(0, Number(item.quantity) || 0);
          group.subtotal += Math.max(0, Number(item.originalLinePrice) || 0);
        }
      });
    });
    var eligible = Array.from(groups.values()).filter(function (group) { return group.quantity >= config.minimumQuantity; });
    eligible.sort(function (a, b) { return b.subtotal - a.subtotal || a.code.localeCompare(b.code); });
    var slots = Math.max(0, config.codeLimit - manual.length);
    return { codes: manual.concat(eligible.slice(0, slots).map(function (group) { return group.code; })), manual: manual, eligible: eligible };
  }

  function install(window) {
    if (window.CamoDesignDiscount) return;
    var document = window.document;
    var settingsNode = document.getElementById('camo-design-discount-settings');
    if (!settingsNode) return;
    var settings;
    try { settings = JSON.parse(settingsNode.textContent); } catch (error) { return; }
    var rawFetch = window.fetch.bind(window);
    var cartUrl = settings.cartUrl.replace(/\/$/, '');
    var revision = 0;
    var dirty = false;
    var timer;
    var active;
    var manualIntent = null;
    var replayingCheckout = false;
    var busBound = false;
    var configPromise = rawFetch(settings.configUrl).then(readJson).then(function (config) {
      if (config.version !== 1 || config.percentage !== 15 || config.minimumQuantity !== 2 || config.codeLimit !== 5 || !Array.isArray(config.groups)) throw new Error('Invalid design offer configuration');
      showOffers(config);
      return config;
    });
    var service = { synchronize: synchronize, ready: configPromise, lastPlan: null, lastCart: null };
    window.CamoDesignDiscount = service;

    function readJson(response) {
      if (!response.ok) throw new Error('Design offer request failed: ' + response.status);
      return response.json();
    }

    function showOffers(config) {
      if (!config.enabled) return;
      var tags = new Set(config.groups.map(function (group) { return String(group.tag).trim().toLowerCase(); }));
      document.querySelectorAll('also-available-carousel[data-design-tag]').forEach(function (carousel) {
        var tag = String(carousel.dataset.designTag).trim().toLowerCase();
        if ((!tags.has(tag) && !(config.autoRegisterDesigns === true && designIdentity(tag))) || carousel.querySelector('[data-design-discount-offer]')) return;
        var heading = carousel.querySelector('.also-available__header');
        if (!heading) return;
        var text = document.createElement('p');
        text.className = 'camo-design-discount-offer';
        text.dataset.designDiscountOffer = '';
        text.textContent = settings.offerText;
        heading.insertAdjacentElement('afterend', text);
      });
    }

    function labelDiscounts() {
      document.querySelectorAll('.cart-item-drawer__details-text span, .cart-item__details-text span').forEach(function (span) {
        Array.from(span.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && managed(node.nodeValue.trim())) node.nodeValue = ' ' + settings.labelText;
        });
      });
    }
    var labelTimer;
    var labelObserver = new MutationObserver(function (records) {
      if (!records.some(function (record) { return record.target.nodeType === 1 && record.target.closest('[data-section-type="cart-template"]'); })) return;
      window.clearTimeout(labelTimer);
      labelTimer = window.setTimeout(labelDiscounts, 0);
    });
    labelObserver.observe(document.body, { childList: true, subtree: true });
    labelDiscounts();

    function sameCodes(a, b) { return unique(a).sort().join(',') === unique(b).sort().join(','); }
    function signature(items, metadata) {
      return items.map(function (item) { return String(metadata ? item.variantId : item.variant_id) + ':' + item.quantity; }).sort().join('|');
    }

    async function synchronize() {
      dirty = true;
      window.clearTimeout(timer);
      if (active) return active;
      active = (async function () {
        var config = await configPromise;
        if (!config.enabled) return;
        var attempts = 0;
        while (dirty && attempts++ < 8) {
          dirty = false;
          var readRevision = revision;
          var metadataUrl = new URL(cartUrl, window.location.origin);
          metadataUrl.searchParams.set('view', 'design-discounts');
          metadataUrl.searchParams.set('_', String(Date.now()));
          var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewId) metadataUrl.searchParams.set('preview_theme_id', previewId);
          var responses = await Promise.all([
            rawFetch(cartUrl + '.js', { cache: 'no-store' }).then(readJson),
            rawFetch(metadataUrl.href, { cache: 'no-store' }).then(readJson)
          ]);
          var cart = responses[0];
          var metadata = responses[1];
          if (!Array.isArray(metadata.items)) throw new Error('Design offer cart metadata is unavailable');
          if (readRevision !== revision || signature(cart.items, false) !== signature(metadata.items, true)) { dirty = true; continue; }
          var plan = planCodes(metadata, cart, config, manualIntent);
          service.lastPlan = plan;
          service.lastCart = cart;
          if (sameCodes(plan.codes, collectCodes(cart))) continue;
          var sectionIds = Array.from(document.querySelectorAll('[data-section-type="cart-template"]')).map(function (section) { return section.dataset.sectionId; }).filter(Boolean).slice(0, 5);
          var request = { discount: plan.codes.join(',') };
          if (sectionIds.length) { request.sections = sectionIds; request.sections_url = window.location.pathname; }
          cart = await rawFetch(cartUrl + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) }).then(readJson);
          service.lastCart = cart;
          if (window.themeCore && window.themeCore.EventBus) {
            window.themeCore.cartObject = cart;
            window.themeCore.EventBus.emit('cart:updated', Object.assign({}, cart, { action: 'designDiscount', params: [{ noOpen: true }] }));
          }
          document.dispatchEvent(new CustomEvent('camo:design-discount:updated', { detail: cart }));
        }
        if (dirty) throw new Error('Cart kept changing while updating the design offer');
        return service.lastCart;
      })();
      try { return await active; } finally { active = null; }
    }

    function schedule() {
      dirty = true;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { synchronize().catch(reportError); }, 120);
    }

    function reportError(error) {
      window.console.warn('[CamoSignal design offer]', error.message);
    }

    function noteDiscountIntent(input, options, url) {
      var body = options && options.body;
      var discount;
      try {
        if (typeof body === 'string') {
          try { discount = JSON.parse(body).discount; } catch (error) { discount = new URLSearchParams(body).get('discount'); }
        } else if (body && typeof body.get === 'function') discount = body.get('discount');
      } catch (error) { return; }
      if (typeof discount === 'string') manualIntent = unique(discount.split(',')).filter(function (code) { return !managed(code); });
      var match = url.pathname.match(/\/discount\/([^/]+)/);
      if (match) manualIntent = unique((manualIntent || collectCodes(service.lastCart || {}).filter(function (code) { return !managed(code); })).concat(decodeURIComponent(match[1])));
    }

    window.fetch = function (input, options) {
      var url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin); } catch (error) { return rawFetch(input, options); }
      var method = String((options && options.method) || (input && input.method) || 'GET').toUpperCase();
      var mutation = url.origin === window.location.origin && (/\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname) && method !== 'GET' || /\/discount\/[^/]+/.test(url.pathname));
      if (!mutation) return rawFetch(input, options);
      revision++;
      noteDiscountIntent(input, options, url);
      return rawFetch(input, options).then(function (response) { if (response.ok) schedule(); return response; });
    };

    function bindBus() {
      if (busBound || !window.themeCore || !window.themeCore.EventBus) return;
      busBound = true;
      window.themeCore.EventBus.listen('cart:updated', function (cart) { if (!cart || cart.action !== 'designDiscount') schedule(); });
    }
    bindBus();
    document.addEventListener('theme:all:loaded', bindBus);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (replayingCheckout || !form || !form.action || new URL(form.action, window.location.origin).pathname !== cartUrl) return;
      var button = event.submitter;
      if (button ? button.name !== 'checkout' : !form.querySelector('[name="checkout"]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      synchronize().catch(reportError).then(function () {
        var target = form.isConnected ? form : document.querySelector('form[action="' + cartUrl + '"]');
        if (!target) return;
        replayingCheckout = true;
        try { target.requestSubmit(button && button.isConnected && button.form === target ? button : undefined); } finally { replayingCheckout = false; }
      });
    }, true);

    document.addEventListener('click', function (event) {
      var checkoutButton = event.target.closest && event.target.closest('.js-checkout-button');
      if (checkoutButton && !event.defaultPrevented && !checkoutButton.disabled && checkoutButton.getAttribute('aria-disabled') !== 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        synchronize().catch(reportError).then(function () { window.location.assign(cartUrl.replace(/\/cart$/, '/checkout')); });
        return;
      }
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
      var url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || !/\/checkout\/?$/.test(url.pathname)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      synchronize().catch(reportError).then(function () { window.location.assign(url.href); });
    }, true);

    if (settings.cartCount > 0 || window.location.pathname === cartUrl) schedule();
    window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(); });
    configPromise.catch(reportError);
  }

  return { collectCodes: collectCodes, planCodes: planCodes, designIdentity: designIdentity, install: install };
});
